
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/items/vipped",
      function () {
        return require("private-next-pages/items/vipped.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/items/vipped"])
      });
    }
  